import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Initialize Firebase
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCYygm-3Qr5lY3UwaaG5fqBjQuAhkHQqVU",
  authDomain: "lodis-signals.firebaseapp.com",
  projectId: "lodis-signals",
  storageBucket: "lodis-signals.firebasestorage.app",
  messagingSenderId: "994105327554",
  appId: "1:994105327554:web:cd14a6a3c81542dca9605b",
  measurementId: "G-Y1H43W27BN"
};

const app = initializeApp(firebaseConfig);
getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
